import { getSvgFromSystem, SystemIcon } from '@helpers/systemIcons';
// import useScrollLock from '@hooks/useBodyScrollLock';
import * as React from 'react';
import { BlogFilterStyles as S } from './BlogFilter.styles';
import Dropdown from '@stories/Components/Dropdown/Dropdown';
import Button from '@stories/Components/Buttons/GeneralButton/Button';
import { ComponentTheme } from '@helpers/themeEnum';
import { useOutsideClick } from '@hooks/useOutsideClick';
const BlogFilter = ({ title, items, activeBlogFilter, sortBy, firstNum, secondNum, totalItems, translations, onFilterSelect, onFilterClear, onSortBy, }) => {
    const mobileFilterRef = React.useRef(null);
    const [visibleOnMobile, setVisibleOnMobile] = React.useState(false);
    const [filterOpen, setFilterOpen] = React.useState(false);
    // useScrollLock(mobileFilterRef.current, visibleOnMobile);
    const replaceHyphensWithSpaces = (value) => {
        return value.replace(/-/g, ' ');
    };
    const containerRef = useOutsideClick(() => {
        setFilterOpen(false);
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(S.MobileToggleButton, null,
            React.createElement(Button, { title: title, styleType: "pill", branding: ComponentTheme.Black, buttonSize: "small", addon: getSvgFromSystem(SystemIcon.Filter), addonPosition: 'left', onClick: () => setVisibleOnMobile(true) })),
        React.createElement(S.ListingTotalsMobile, null,
            React.createElement(S.ListingTotalsText, null,
                translations && (translations['translations.blog.showing'] ?? 'Showing'),
                " ",
                firstNum,
                " -",
                ' ',
                secondNum,
                " ",
                translations && (translations['translations.blog.of'] ?? 'of'),
                " ",
                ' ',
                React.createElement("span", null,
                    ' ',
                    " ",
                    totalItems,
                    " ",
                    ' ',
                    " ",
                    translations && (translations['translations.blog.results'] ?? 'Articles')))),
        React.createElement(S.Container, { ref: mobileFilterRef, "data-visible-mobile": visibleOnMobile },
            React.createElement(S.FilterArea, null,
                React.createElement(S.MobileSortBy, null, sortBy && onSortBy && (React.createElement(Dropdown, { labelText: sortBy.labelText, options: sortBy.options, value: sortBy.value, onOptionChange: (val) => onSortBy(val) }))),
                React.createElement(S.FilterList, { ref: containerRef },
                    React.createElement(S.MobileTitle, null, title),
                    React.createElement(S.CatButton, { type: 'button', onClick: () => setFilterOpen(!filterOpen), "data-filter-open": filterOpen },
                        title,
                        " ",
                        getSvgFromSystem(SystemIcon.ChevronRight)),
                    React.createElement(S.CatList, { "data-filter-open": filterOpen },
                        React.createElement(S.CatListInner, null, items &&
                            items.map((item) => {
                                const isActive = activeBlogFilter && activeBlogFilter.includes(item.value);
                                return (React.createElement(S.FilterButton, { type: 'button', key: item.id, title: item.text, "data-active": isActive, onClick: () => onFilterSelect(item.value) },
                                    getSvgFromSystem(SystemIcon.TickColourFlexible),
                                    item.text));
                            })))),
                React.createElement(S.ListingTotals, null,
                    React.createElement(S.ListingTotalsText, null,
                        translations && (translations['translations.blog.showing'] ?? 'Showing'),
                        " ",
                        firstNum,
                        " -",
                        ' ',
                        secondNum,
                        " ",
                        translations && (translations['translations.blog.of'] ?? 'of'),
                        " ",
                        ' ',
                        React.createElement("span", null,
                            ' ',
                            " ",
                            totalItems,
                            " ",
                            ' ',
                            " ",
                            translations && (translations['translations.blog.results'] ?? 'Articles')))),
                React.createElement(S.DesktopSortBy, null, sortBy && onSortBy && (React.createElement(Dropdown, { labelText: sortBy.labelText, options: sortBy.options, value: sortBy.value, onOptionChange: (val) => onSortBy(val) }))),
                React.createElement(S.ApplyFilter, null,
                    React.createElement(S.ApplyFilterBtn, { title: `View ${totalItems} Articles`, styleType: "pill", buttonSize: "small", onClick: () => setVisibleOnMobile(false) }))),
            React.createElement(S.SelectedFilters, null,
                activeBlogFilter && activeBlogFilter.length > 0 && (React.createElement(S.Clear, { title: "Clear All", styleType: "underline", buttonSize: 'small', addon: getSvgFromSystem(SystemIcon.StyledX), addonPosition: "left", onClick: onFilterClear })),
                activeBlogFilter && activeBlogFilter.map((filter) => (React.createElement(S.SelectedFilterButton, { key: filter, styleType: 'pill', backgroundPlacement: 'dark', buttonSize: 'small', title: replaceHyphensWithSpaces(filter), addon: getSvgFromSystem(SystemIcon.StyledX), addonPosition: "right", onClick: () => onFilterSelect(filter) })))),
            React.createElement(S.Close, { onClick: () => setVisibleOnMobile(false) }, getSvgFromSystem(SystemIcon.Plus)))));
};
export default BlogFilter;
